import { sendImg } from "../../Quizzes/api/websocket";
const suffix = () => {
    return Math.random().toString(36).slice(2);
}

export const openWebSocket = ({
    userImageChanged,
    postImageChanged, screenName,
    postLater, loginAdminToOverview, token, merchantId, userImage, firstPostText, postImage }) => {
    if (postLater) {
        loginAdminToOverview();
    }
    const ENV = localStorage.getItem('envSquadded');
    const SQUAD_ORIGIN = ENV === 'STAGING' || ENV === 'DEV' ? 'squad-shopping.com' : 'squadded.co';
    const socket = new WebSocket(`wss://api.${SQUAD_ORIGIN}/`);
    const sendSocketMessage = (params) => {
        socket.send(JSON.stringify(params));
    };

    let userProfile = null;
    socket.addEventListener('message', async (event) => {
        const msg = JSON.parse(event.data)
        const { type, url, user } = msg;

        if (type === 'authRequest') {
            sendSocketMessage({
                "type": "authResponse",
                "userToken": token,
                merchantId,
                "session": true
            })
        }

        if (type === 'authOk') {
            sendSocketMessage({
                "type": "fetchUser",
            })
        }

        if (type === 'userProfile') {
            userProfile = user;
            sendSocketMessage({
                "type": "getUploadUrl",
                contentType: userImage.type || 'image/png',
            })
        }

        if (type === 'uploadURL' && !postLater) {
            let userImgHref;
            let postImgHref;
            if (userImageChanged) {
                userImgHref = await sendImg({ url, file: userImage });
            } else {
                userImgHref = userImage;
            }

            if (postImageChanged) {
                postImgHref = await sendImg({ url, file: postImage });
            } else {
                postImgHref = postImage;
            }

            userProfile.avatar = userImgHref;
            userProfile.miniAvatar = userImgHref;
            userProfile.screenName = screenName;
            sendSocketMessage({
                "type": "setProfile",
                user: userProfile
            });
            sendSocketMessage({
                autoCustomerService: false,
                correlationId: `${Date.now()}${suffix()}`,
                customerService: false,
                private: false,
                text: firstPostText,
                items: [],
                coords: [],
                img: postImgHref,
                admin: true,
                type: postImgHref ? 'galleryPost' : "questionPost"
            });
            loginAdminToOverview();
        }
    });
};